import { FC } from 'react'
import { IDateTimePickerProps } from './types'
import sharedStyles from '@muiscss/sharedStyles.module.scss'
import styles from './styles.module.scss'
import clsx from 'clsx'

const DateTimePicker: FC<IDateTimePickerProps> = ({
  autoFocus = false,
  disabled = false,
  hasError,
  id,
  label,
  name,
  onBlur,
  onChange,
  onFocus,
  required,
  size = 'md',
  slots,
  style,
  transparent = false,
  type,
  value,
  ...props
}) => {
  return (
    <div className={styles.inputHolder}>
      {label && (
        <label
          className={clsx('mui-timeDatePicker-label', sharedStyles.label, sharedStyles[size], {
            [sharedStyles.disabled]: disabled,
          })}
          data-testid="mui-label"
          htmlFor={id}
        >
          {label} {required && '*'}
        </label>
      )}

      <div className={styles.innerHolder}>
        <input
          autoFocus={autoFocus}
          className={clsx('mui-timeDatePicker', styles.input, styles[size], {
            [sharedStyles.timeDatePickerError]: hasError,
            [styles.withSlotsBefore]: Boolean(slots?.before),
            [styles.withSlotsAfter]: Boolean(slots?.after),
            [styles.transparent]: transparent,
          })}
          data-testid="mui-timeDatePicker"
          disabled={disabled}
          id={id}
          name={name || 'timeDatePicker'}
          required={required}
          style={{ ...style }}
          type={type}
          value={value}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur?.(event)}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange?.(event)}
          onFocus={(event: React.FocusEvent<HTMLInputElement>) => onFocus?.(event)}
          {...props}
        />

        {slots?.before && (
          <span
            className={clsx(styles.slotsBefore, {
              [sharedStyles.inputError]: hasError,
              [styles.transparent]: transparent,
            })}
          >
            {slots.before}
          </span>
        )}

        {slots?.after && (
          <span
            className={clsx(styles.slotsAfter, {
              [sharedStyles.inputError]: hasError,
              [styles.transparent]: transparent,
            })}
          >
            {slots.after}
          </span>
        )}
      </div>
    </div>
  )
}

export default DateTimePicker
